import { useEffect, useState } from "react";
import useRetryFetch from "../../hooks/useRetryFetch";
import {
  addEvidence,
  assessTrait,
  deleteEvidence,
  getTrait,
  updateTrait,
  type AssessmentLevel,
  type UserTrait,
} from "../../api/userTraits";
import TraitDetailPanel from "../spaces/components/TraitDetailPanel";

/** The trait's detail panel (with its growth ladder), opened straight from a capture. */
const CaptureTraitPanel = ({
  traitId,
  open,
  onClose,
  onFailed,
}: {
  traitId: string;
  open: boolean;
  onClose: () => void;
  /** The trait could not be loaded (the caller shows why). */
  onFailed: () => void;
}) => {
  const retryFetch = useRetryFetch();
  const [trait, setTrait] = useState<UserTrait | null>(null);

  useEffect(() => {
    if (!open) return;
    let alive = true;
    getTrait(retryFetch, traitId)
      .then((tr) => {
        if (alive) setTrait(tr);
      })
      .catch(() => {
        if (alive) onFailed();
      });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, traitId]);

  return (
    <TraitDetailPanel
      trait={trait}
      isOpen={open && trait !== null}
      onClose={onClose}
      onUpdate={async (id, data) => setTrait(await updateTrait(retryFetch, id, data))}
      onAssess={async (id, level, note) => setTrait(await assessTrait(retryFetch, id, level as AssessmentLevel, note))}
      onAddEvidence={async (id, data) => setTrait(await addEvidence(retryFetch, id, data))}
      onDeleteEvidence={async (id, evidenceId) => setTrait(await deleteEvidence(retryFetch, id, evidenceId))}
      spaceId={trait?.spaceIds?.[0]}
    />
  );
};

export default CaptureTraitPanel;
